import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FiltroPipe } from '../pipes/filtro.pipe';


import { MochilaService } from '../services/mochila.service';
import { AuthService } from '../services/auth.service';
import { ExcelService } from '../services/excel.service';
import { ClienteService } from '../services/cliente.service';
import { UnidadeService } from '../services/unidade.service';
import { TipoMochilaService } from '../services/tipo-mochila.service';
import Swal from 'sweetalert2';


import { ActivatedRoute, Router } from "@angular/router";
import { PerfilUsuarioService } from '../services/perfil-usuario.service';


@Component({
  selector: 'app-mochila',
  templateUrl: './mochila.component.html',
  styleUrls: ['./mochila.component.css'],
	animations: [loadingFade, modal, alert]
})
export class MochilaComponent implements OnInit {
	public loading = false;
	public mochilas = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	//acesso
	public menu_id = 126; //Cadastro - ADM
	public usuario_perfil;
	public visualizar = true;
	public editar = false;	
	public usuario_exibir_regiao;	
	public showFilter = true;
	public unidades = [];
	public clientes = [];
	public formFiltro: FormGroup;
	public filtro = [];
	public dadosFiltrados = [];
	public tipos_mochila = [];

	constructor(
		private mochilaSvc: MochilaService,
		private authSvc: AuthService,
		private excelSvc: ExcelService,
		private unidadeSvc: UnidadeService,
		private clienteSvc: ClienteService,
		private fb: FormBuilder,
		private tipoMochilaSvc: TipoMochilaService,
		private route: ActivatedRoute,
		private router: Router,	
		private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		}); 

		if(this.usuario_perfil == 16){
			this.editar = true;
		}

		//this.pegaMochilas();
		this.getConsultaPorRegiaoOuMochilas();
		this.criaFiltro();
		this.pegaClientes();
		this.pegaTiposMochila();
	}



	pegaMochilas() {

		this.loading = true;
		this.mochilaSvc.getMochilas().then((data: any) => {
			console.log("[resp] = ", data);
			this.mochilas = data;
			this.count = this.mochilas.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	pegaMochilasRegiao() {

		this.loading = true;
		this.mochilaSvc.getMochilasRegiao(this.authSvc.getUsuarioId()).then((data: any) => {
			console.log("[resp] = ", data);
			this.mochilas = data;
			this.count = this.mochilas.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}
	

	getConsultaPorRegiaoOuMochilas(){

		this.perfilUsuarioSvc.getByUsuarioPerfil(this.usuario_perfil).then((data: any) => {
			
			this.usuario_exibir_regiao = data.usuario_exibir_regiao
			if(this.usuario_exibir_regiao == "A"){
				this.pegaMochilasRegiao();
			}else{
				this.pegaMochilas();
			}

		}).catch((err) => {
			console.log(err);scrollBy
		});  

	  }


	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	apagaMochila(id) {
		Swal.fire({
			type: 'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'

		}).then((result) => {
			if (result.value == true) {
				this.mochilaSvc.apagaMochila(id).then((data) => {
					this.pegaMochilas();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	filtra() {
		this.mochilas = [];
		this.filtro = this.formFiltro.value;
		this.loading = true;
		this.mochilaSvc.getByFiltrarMochila(this.authSvc.getUsuarioId(), this.filtro, this.page).then((data: any) => {
			this.mochilas = data;
			this.loading = false;
		}).catch((err) => {
			this.loading = false;
			console.log(err);
		});


	}

	onChangeCliente(evento) {
		this.formFiltro.controls.unidade_id___unidade.setValue(null);
		this.unidadeSvc.getUnidadesByUsuarioAndCliente(this.authSvc.getUsuarioId(), evento.cliente_id).then((data: any) => {
		  this.unidades = data;
		}).catch((err) => {
		  console.log(err);
		});
	  }

	  criaFiltro() {
		this.formFiltro = this.fb.group({
			mochila_nome: '',
			tipo_mochila_id___tipo: null,
			cliente_id___cliente: null,
			unidade_id___unidade: null
		});
		//this.showFilter = false;
	}

	onClickLimparCampos(){
		this.formFiltro = this.fb.group({
			mochila_nome: '',
			tipo_mochila_id___tipo: null,
			cliente_id___cliente: null,
			unidade_id___unidade: null
		});

		

	  }

	expandPanel() {
		this.showFilter = this.showFilter == true ? false : true;
	}

	pegaClientes() {
		this.clienteSvc.getClientesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
		  this.clientes = data;
		});
	}

	pegaTiposMochila() {
		this.tipoMochilaSvc.getTiposMochilaAtivas().then((data: any[]) => {
			this.tipos_mochila = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	VerMochila(mochila_id){	
		this.router.navigate(['home/mochila/ver/' + mochila_id]);
	}

}
